
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  Grid,
  GridItem,
  Size,
  Flex,
  FlexItem,
  FlexJustify,
  TextLink,
  Category,
} from '@drawbotics/react-drylus';
import { css } from '@emotion/css';
import sv from '@drawbotics/drylus-style-vars';
export const Package = ({
  children
}) => {
  return <div className={css`
      border: 1px solid ${sv.neutral};
      border-radius: ${sv.defaultBorderRadius};
      padding: ${sv.defaultPadding};
    `}>
      {children}
    </div>;
};
export const packages = ['drylus-style-vars', 'icons', 'extract-emotion', 'react-drylus', 'vanilla-drylus'];

const layoutProps = {
  Package,
packages
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

<h1>{`Packages`}</h1>
<p>{`Below are the different packages and their current version.`}</p>


<Grid hGutters={Size.DEFAULT} vGutters={Size.DEFAULT} columns={3} responsive={{
      XL: {
        columns: 2
      },
      L: {
        columns: 1
      }
    }} mdxType="Grid">
  {packages.map(name => <GridItem key={name} mdxType="GridItem">
      <Package mdxType="Package">
        <Flex justify={FlexJustify.SPACE_BETWEEN} mdxType="Flex">
          <FlexItem mdxType="FlexItem">
            <a href={`https://badge.fury.io/js/%40drawbotics%2F${name}`}>
              <TextLink category={Category.INFO} mdxType="TextLink">{name}</TextLink>
            </a>
          </FlexItem>
          <FlexItem mdxType="FlexItem">
            <img src={`https://badge.fury.io/js/%40drawbotics%2F${name}.svg`} />
          </FlexItem>
        </Flex>
      </Package>
    </GridItem>)}
</Grid>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;